
import { supabase } from "@/integrations/supabase/client";
import { WorksheetQueryResult } from "./types";
import { useToast } from "@/hooks/use-toast";

export const useWorksheetFetch = () => {
  const { toast } = useToast();

  const fetchWorksheets = async (
    from: number,
    to: number,
    searchQuery: string,
    sortField: string,
    sortDirection: "asc" | "desc",
    subjectFilter: string
  ): Promise<WorksheetQueryResult> => {
    try {
      // Start building the query
      let query = supabase
        .from("worksheets")
        .select("*", { count: "exact" });
      
      // Add search filter if provided
      if (searchQuery && searchQuery.length > 1) {
        query = query.ilike("search_index", `%${searchQuery}%`);
      }
      
      // Add subject filter if not "all"
      if (subjectFilter !== "all") {
        query = query.eq("subject", subjectFilter);
      }
      
      // Count total matching rows first
      const { count: totalMatchingRows, error: countError } = await query;
      
      if (countError) throw countError;
      
      // Then get the data with pagination and sorting
      const { data, error } = await query
        .order(sortField, { ascending: sortDirection === "asc" })
        .range(from, to);
      
      if (error) throw error;
      
      return { data: data || [], totalCount: totalMatchingRows || 0 };
    } catch (error: any) {
      console.error("Error fetching worksheets:", error.message);
      toast({
        title: "เกิดข้อผิดพลาด",
        description: `ไม่สามารถดึงข้อมูลชีทได้: ${error.message}`,
        variant: "destructive"
      });
      return { data: [], totalCount: 0 };
    }
  };

  return { fetchWorksheets };
};
